import React, { PureComponent } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  FormGroup,
  Label,
  Input
} from "reactstrap";
import { CLOUDINARY_THUMB } from "../../helpers/cloudinaryConstants";

export default class CopyInventoryModal extends PureComponent {
  constructor(props) {
    super(props);
    this.onConfirm = this.onConfirm.bind(this);
    this.close = this.close.bind(this);
  }

  onConfirm() {
    this.props.onConfirm();
  }
  close() {
    this.props.close();
  }

  renderLoading() {
    return (
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center"
        }}
      >
        <h5>Working, this may take a while...</h5>
      </div>
    );
  }

  render() {
    const { sourceBusiness, targetBusiness } = this.props;

    return sourceBusiness && targetBusiness ? (
      <Modal
        isOpen={this.props.isOpen}
        toggle={this.toggle}
        className={this.props.className}
      >
        <ModalHeader toggle={this.props.close}>
          Confirm Inventory Copy
        </ModalHeader>
        <ModalBody>
          {this.props.copying ? (
            this.renderLoading()
          ) : (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between"
              }}
            >
              <h5>From:</h5>
              <div style={{ display: "flex", alignItems: "center" }}>
                <div className="avatar">
                  <img
                    src={`${CLOUDINARY_THUMB}/${
                      sourceBusiness.business.avatar.image.cloudinaryId
                    }`}
                    className="img-avatar"
                    alt={sourceBusiness.business.name}
                  />
                </div>
                <h5 style={{ marginLeft: "5px" }}>
                  {sourceBusiness.business.name}
                </h5>
              </div>
              <h5>To:</h5>
              <div style={{ display: "flex", alignItems: "center" }}>
                <div className="avatar">
                  <img
                    src={`${CLOUDINARY_THUMB}/${
                      targetBusiness.business.avatar.image.cloudinaryId
                    }`}
                    className="img-avatar"
                    alt={targetBusiness.business.name}
                  />
                </div>
                <h5 style={{ marginLeft: "5px" }}>
                  {targetBusiness.business.name}
                </h5>
              </div>
            </div>
          )}
        </ModalBody>
        <ModalFooter>
          <Button
            color="primary"
            disabled={this.props.copying}
            onClick={this.onConfirm}
          >
            Confirm
          </Button>
          <Button color="secondary" onClick={this.close}>
            Cancel
          </Button>
        </ModalFooter>
      </Modal>
    ) : null;
  }
}



// WEBPACK FOOTER //
// ./src/views/Components/CopyInventoryModal.js